import { BRAZE_FORM_FIELDS } from './constants'
import { applyAttributeFieldGuide } from './attribute-field-guide'

/** Form fields for the Custom Attributes tab, including BIL-3009 operator guidance. */
export const BRAZE_FORM_FIELDS_WITH_GUIDE = applyAttributeFieldGuide(BRAZE_FORM_FIELDS)
